import { ChangeEvent } from 'react';

/** Возвращает функцию, которая создает ненастоящий объект ChangeEvent */
export function useFakeChangeEvent(inputName: string | undefined) {
  return (value: string) =>
    ({
      target: { value, name: inputName }
    }) as ChangeEvent<HTMLInputElement>;
}
